<template>
  <div
    id="div-loader"
    class="loader"
  >
    <img
      src="/images/ripple-loading-rebrand.gif"
      alt="loading"
    />

    <slot />
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsLoadingAnimation'
})
</script>

<style scoped>
.loader {
  display: flex;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.46);
  align-items: center;
  justify-content: center;
}
  .loader img {
    width: 6.25rem;
  }
</style>
